import { HttpRequest } from "../utils";

const httpRequest = new HttpRequest();

export const calculateBatch = async (data: {
  buyerBusinessId: string;
  variants: Array<{ variantId: string; quantity?: number }>;
}) => httpRequest.post("/inv/price/calculate-batch", data);
